import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { GiphyFetch } from '@giphy/js-fetch-api';
import { Subject } from 'rxjs/internal/Subject';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { IGif, ImageAllTypes } from '@giphy/js-types';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { LoaderComponent } from '@sb-tools/typescript/components/loader/loader.component';

const gf = new GiphyFetch('gQ7lLQ9hjokyXDlBVbvU1Tgr11S6gGz6');

@Component({
    selector: 'sb-giphy-popover',
    templateUrl: './giphy-popover.component.html',
    styleUrls: ['./giphy-popover.component.scss'],
    imports: [TranslateModule, FormsModule, InfiniteScrollModule, LoaderComponent],
})
export class GiphyPopoverComponent implements OnInit, OnDestroy {
    @Output() add: EventEmitter<ImageAllTypes> = new EventEmitter();

    giphyResults: IGif[] = [];
    isLoadingGifs = true;
    searchQuery = '';
    searchQueryUpdate = new Subject<string>();

    private offset = 0;
    private sum = 10;
    private unsubscriber = new Subject<void>();

    ngOnInit(): void {
        this.getTrendyGifs();

        this.searchQueryUpdate
            .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.unsubscriber))
            .subscribe((value) => {
                this.sum = 0;
                this.offset = this.sum;
                this.giphyResults.length = 0;
                if (value) {
                    this.startGiphySearch(value);
                } else {
                    this.getTrendyGifs();
                }
            });
    }

    loadMore(): void {
        if (this.isLoadingGifs) {
            return;
        }

        this.offset = this.sum;
        this.sum += 10;

        if (this.searchQuery) {
            this.startGiphySearch(this.searchQuery);
        } else {
            this.getTrendyGifs();
        }
    }

    sendGif(gif: ImageAllTypes): void {
        this.add.emit(gif);
    }

    private getTrendyGifs(): void {
        this.isLoadingGifs = true;

        gf.trending({ limit: 10, offset: this.offset })
            .then((res) => {
                this.giphyResults = this.giphyResults.concat(res.data);

                setTimeout(() => {
                    this.isLoadingGifs = false;
                }, 1000);
            })
            .catch(console.error);
    }

    private startGiphySearch(searchText: string): void {
        this.isLoadingGifs = true;

        gf.search(searchText, { limit: 10, offset: this.offset })
            .then((res) => {
                this.giphyResults = this.giphyResults.concat(res.data);

                setTimeout(() => {
                    this.isLoadingGifs = false;
                }, 1000);
            })
            .catch(console.error);
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
